export const files = state => state.files.items

export const fileById = state => id => _.find(files(state), {id})

export const filesByReference = state =>
    (reference_type, reference_id) => {
        reference_id = reference_id ? parseInt(reference_id) : reference_id
        if (reference_type === 'project') {
            return _.filter(files(state), {project_id: reference_id})
        } else {
            return _.filter(files(state), {reference_type, reference_id})
        }
    }

export const filesByProjectId = (state, getters) => project_id => _.filter(getters.files, {project_id})